var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCharacterHeadIndividual1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 146 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{clip-path:url(#clip-path);}.cls-3,.cls-6,.cls-9{fill:#6d5331;}.cls-3,.cls-5,.cls-7,.cls-8{fill-rule:evenodd;}.cls-4,.cls-8{fill:#fbe8ce;}.cls-5{fill:#685d4a;}.cls-7{fill:#efcba5;}.cls-9{opacity:0.1;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 146,
    height: 116
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M73.7,19.8S122.4,41.39,122.4,68a47.86,47.86,0,0,0,21.1,40,48.34,48.34,0,0,1-45.59,32.23H73.7V19.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M72.67,140.34h-24A48.22,48.22,0,0,1,3.19,108.07,48.14,48.14,0,0,0,24.53,68,48.05,48.05,0,0,1,72.67,19.8V140.34Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-4",
    cx: 72.38,
    cy: 58.14,
    rx: 44.2,
    ry: 31.54
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M117.24,56.5l.22,39.73a11.58,11.58,0,0,1-.6,4A79.45,79.45,0,0,1,96.77,131a85.1,85.1,0,0,1-16.43,12.19c-3.14,1.8-6,3-9.81,2.8-3.56-.2-6.33-1.84-9.23-3.58a84,84,0,0,1-24.93-22.77,26.61,26.61,0,0,1-3.12-5.48A69.32,69.32,0,0,1,29,102.36a11.59,11.59,0,0,1-.56-2.7V55.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M77.83,127c3.91,0,6.56-6.23,6.56-11l-12.72,1.64L59,115.9a12.45,12.45,0,0,0,6.55,11H77.83Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M117.61,66.2c0-15.45-21.34-25.16-44.39-25.3-19-.12-44.35,9.85-44.35,25.3H24.62A48.78,48.78,0,0,1,73.23,17.35h0A49,49,0,0,1,122.28,66.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M74.67,91.5,74.29,84a1.87,1.87,0,0,0-3.74.19h0l.29,5.63-1.89.1a5.63,5.63,0,0,0,.57,11.25l3.75-.2a1.87,1.87,0,0,0,1.78-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M115,78.17a9,9,0,1,0,7.72,10.06A9,9,0,0,0,115,78.17Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M114.43,82.61a4.49,4.49,0,1,0,3.86,5,4.49,4.49,0,0,0-3.86-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.93,78.17a9,9,0,1,0,7.72,10.06,9,9,0,0,0-7.72-10.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M30.34,82.23a4.48,4.48,0,1,0,3.86,5,4.48,4.48,0,0,0-3.86-5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M47.69,72.38c-.79,0-1.43-.24-1.43-1s.64-1,1.43-1H59.12c.79,0,1.43.24,1.43,1s-.64,1-1.43,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M83.41,72.38c-.79,0-1.43-.24-1.43-1s.64-1,1.43-1H94.84c.79,0,1.43.24,1.43,1s-.64,1-1.43,1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M84.13,79.71a1.42,1.42,0,1,1-1.43-2.46,12.85,12.85,0,0,1,12.86,0,1.42,1.42,0,1,1-1.43,2.46,10,10,0,0,0-10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.4,79.71A1.42,1.42,0,1,1,47,77.25a12.85,12.85,0,0,1,12.86,0,1.42,1.42,0,0,1-1.42,2.46,10,10,0,0,0-10,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M112.61,95.8s-7.76,12.27-9.58,13.35c-8,4.71-19.4-2.36-31.71-2.36-8.13,0-21.49,5.76-24.64,3.54A72.3,72.3,0,0,1,32,95.67l-5.53.26A65.52,65.52,0,0,0,35,117.6C43.35,131.07,61.55,146,71.77,146s30.55-18.28,37.41-29.43A127,127,0,0,0,119.8,95.78ZM72.66,131.71c-11,0-15.83-10.74-15.83-17.82,0,0,31.41-.24,31.41-.2C88.24,120.78,83.65,131.71,72.66,131.71Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 27.15,
    y: 53.86,
    width: 5.02,
    height: 41.94
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 112.61,
    y: 53.86,
    width: 5.02,
    height: 41.94
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCharacterHeadIndividual1);
export default __webpack_public_path__ + "static/media/character-head-individual-1.fc621bdec949c47239bd76f2aaed053c.svg";
export { ForwardRef as ReactComponent };